import * as get from 'lodash/get';

import { ColumnExtractor } from './column-extractor';

/**
 * This extractor is to combine extractor (similar to LodashExtractor) and formatter together 
 * to support conditional extraction of data (use in conjunction with ConditionalExtractor)
 * 
 * For example
 * ConditionalExtractor([
 * 		ExtractAndFormatExtractor('path','default',(value)=>value + 'add this word when true'),
 * 		ExtractAndFormatExtractor('path','default',(value)=>value + 'add this word when false')
 * ])
 * 
 */
export class ExtractAndFormatExtractor implements ColumnExtractor {
	constructor(public readonly expression: string, public readonly defaultValue?: number | string, public readonly formatter?: (value: number | string) => number | string) { }
	public extractor(): (storeData: any) => number | string {
		return (storeData: any) => {
			const extractedValue = get(storeData, this.expression, this.defaultValue);
			return this.formatter(extractedValue);
		};
	}

	public getDataPointPath(): string {
		return this.expression;
	}
}
